import { HttpService } from '@/api/shared/http.service'
import { migrateFromV1ToV3 } from '@/api/shared/utils'

import {
  CounterData,
  CountersListPayload,
  Resource,
  ResourceAlias
} from './counters.types'

export type CounterValues = {
  alias: string
  value: string
}

export type TariffHistory = {
  alias: string
  name: string
  value: number
  delta: number
}

export type CounterHistory = {
  name: string
  serialNumber: string
  resourceAlias: ResourceAlias
  items: CounterHistoryItem[]
}

export type CounterHistoryItem = {
  approvedAt: string
  tariffs: TariffHistory[]
}

class CountersService extends HttpService {
  async getCountersList(params: CountersListPayload) {
    const { data } = await this.axios.get<{ data: CounterData[] }>(
      migrateFromV1ToV3(this.getPath('/counters')),
      { params }
    )

    return data
  }

  async getCountersResources(projectId: string) {
    const { data } = await this.axios.get<Resource[]>(
      this.getPath('/counters/resources'),
      {
        params: { projectId }
      }
    )

    return data
  }

  async sendCounterValues(id: string, values: CounterValues[]) {
    await this.axios.post(this.getPath(`/counters/${id}/readings`), values)
  }

  async getHistory(id: string) {
    const { data } = await this.axios.get<CounterHistory>(
      this.getPath(`counters/${id}/history`)
    )

    return data
  }
}

const CountersServiceSingleton = new CountersService('/api/v1')
export { CountersServiceSingleton as CountersService }
